import { TENNAT_API_URL } from '@services/.env'
import { post } from '@services/base.api.service'
import { BaseService } from '@services/base.service'

export default class BirthdayService extends BaseService {
  static fetchBirthdays(payload) {
    return new Promise((resolve, reject) => {
      return post(`${TENNAT_API_URL}birthdays/filter`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not load birthdays'
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
